<template>
  <div class="hero-section" v-loading="loading" element-loading-text="加载中...">
    <el-carousel v-if="banners.length > 0" :interval="5000" arrow="hover" height="650px">
      <el-carousel-item v-for="(item, index) in banners" :key="item.id || index">
        <div class="hero-slide" :style="{ backgroundImage: `url(${item.image})` }"></div>
      </el-carousel-item>
    </el-carousel>
    <!-- 如果没有数据，显示默认背景 -->
    <div v-else class="hero-slide"></div>
  </div>
</template>

<script>
import { getActiveBanners } from '@/api/banner'

export default {
  name: 'Hero',
  data() {
    return {
      banners: [],
      loading: false
    }
  },
  created() {
    this.loadBanners()
  },
  methods: {
    /**
     * 加载轮播图数据
     * 目前只使用 imageUrl 字段
     */
    loadBanners() {
      this.loading = true
      getActiveBanners()
        .then(response => {
          if (response.code === 200) {
            const list = response.rows || []
            if (list && list.length > 0) {
              // 只提取 imageUrl 字段
              this.banners = list
                .filter(item => item.imageUrl) // 过滤掉没有图片的项
                .map(item => ({
                  id: item.id,
                  image: this.formatImageUrl(item.imageUrl)
                }))
            }
            // 如果没有数据，banners 保持为空数组，显示默认背景
          } else {
            console.warn('获取轮播图失败:', response.msg)
          }
        })
        .catch(error => {
          console.error('获取轮播图失败:', error)
          // API失败时不显示轮播图，显示默认背景
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 格式化图片URL
     * 如果是相对路径，需要拼接基础URL
     * 如果是绝对路径，直接返回
     */
    formatImageUrl(url) {
      if (!url) {
        return ''
      }
      // 如果是绝对路径，直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 相对路径，拼接基础URL
      const baseUrl = process.env.VUE_APP_BASE_API || '/api'
      // 如果URL已经以/开头，直接拼接baseUrl
      if (url.startsWith('/')) {
        return `${baseUrl}${url}`
      }
      return `${baseUrl}/${url}`
    }
  }
}
</script>

<style scoped>
.hero-section {
  width: 100%;
}

.hero-slide {
  width: 100%;
  height: 650px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}

.el-carousel__arrow {
  background-color: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.5);
}

.el-carousel__arrow:hover {
  background-color: rgba(234, 64, 67, 0.8);
  border-color: #EA4043;
}

@media (max-width: 768px) {
  .hero-slide {
    height: 500px;
    background-attachment: scroll;
  }
}
</style>
